import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS, apiRequest } from '@/lib/api';

export function useProjectData(projectId: number | null, sprintId?: number | null) {
  return useQuery({
    queryKey: ['project', projectId, 'tasks', sprintId],
    queryFn: async () => {
      if (!projectId) {
        throw new Error('Project ID is required');
      }

      let url = `${API_ENDPOINTS.TASKS.LIST}?project=${projectId}&archive=false`;
      if (sprintId) {
        url += `&sprint=${sprintId}`;
      }

      const response = await apiRequest(url);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ 
          detail: 'Failed to fetch project tasks' 
        }));
        throw new Error(errorData.detail || 'Failed to fetch project tasks');
      }

      const data = await response.json();
      return data.results || data;
    },
    enabled: !!projectId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export function useProjectBoards(projectId: number | null) {
  return useQuery({
    queryKey: ['project', projectId, 'boards'],
    queryFn: async () => {
      if (!projectId) {
        throw new Error('Project ID is required');
      }

      const response = await apiRequest(
        `${API_ENDPOINTS.BOARDS}?project=${projectId}`
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ 
          detail: 'Failed to fetch boards' 
        }));
        throw new Error(errorData.detail || 'Failed to fetch boards');
      }

      const data = await response.json();
      return data.results || data;
    },
    enabled: !!projectId && projectId !== 0, // Only fetch for Product Development projects (type 0)
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}



